import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/api";

export type FilmDropRecord = {
  rowid: number | string;
  "invoice-id"?: string;
  timestamp?: string;
  "full-name"?: string;
  email?: string;
  "color-35"?: number;
  "bw-35"?: number;
  "color-120"?: number;
  "bw-120"?: number;
  "scan-resolution"?: string;
  "file-format"?: string;
  "negative-return"?: string;
  notes?: string;
  "negative-pickup"?: string;
  "contact-sheet"?: number | string;
  "scan-gallery"?: string;
  prints?: string;
  "join-club"?: string;
  "club-member"?: unknown;
  "customer-form"?: string;
  "mail-back-pdf"?: string;
  "mail-in-pdf"?: string;
  order_type?: string;
  [k: string]: unknown;
};
export type FilmDropSummary = { today: number; week: number; month: number };

export function useFilmDrop(range: { start: string; end: string } | null, enabled: boolean) {
  return useQuery({
    queryKey: ["film-drop", range?.start ?? "", range?.end ?? ""],
    queryFn: () => {
      let url = "film-drop";
      if (range && range.start && range.end) url += `?dateRange=${range.start},${range.end}`;
      return apiCall<{ records: FilmDropRecord[]; summary: FilmDropSummary }>(url);
    },
    enabled,
  });
}
